import { render, staticRenderFns } from "./ci_resources_list_item.vue?vue&type=template&id=db769b94"
import script from "./ci_resources_list_item.vue?vue&type=script&lang=js"
export * from "./ci_resources_list_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports